export default "https://assets-v2.scaler.com/packs/images/user-circle-plus.5c9937.svg";